import {axiosUtil} from "../../../utils/axios_util";

const videoListApi = {
    //分页查询视频
    getRecordingPage(data:powerSearchData) {
        return axiosUtil({
            url: '/call/recording/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //获取录音下载地址地址
    getDownloadUrl(data:any) {
        return axiosUtil({
            url: `/call/recording/download/getPreSignedUrl?objectName=${data.objectNames}`,
            method: 'get'
        })
    },
    //获取录音配置
    getrecordingConfig() {
        return axiosUtil({
            url: `/call/recording/config/get`,
            method: 'get'
        })
    },
    //设置录音存储时间
    setrecordingConfig(data:any) {
        return axiosUtil({
            url: `/call/recording/config/update`,
            method: 'post',
            data
        })
    },

}

export default videoListApi
